import { createContext, useState, useContext, useEffect } from "react";
import { io } from "socket.io-client";
import { useDispatch } from "react-redux";


import {
  setTradesLoadingFinished,
  setFinishLoading
} from "../../actions/tradesActions";

//http://68.183.24.125/
// ⚙️ Configura el socket global
//const socket = io("https://www.inlazuai.com/", {
  //autoConnect: false,
  //transports: ["websocket"],
//});
const socket = io("http://localhost:5000/", {
  transports: ["polling", "websocket"],
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 2000
});
// 🧩 Crea el contexto
const SyncContext = createContext();

export function SyncProvider({ children }) {
  const [progress1, setProgress1] = useState(0);
  const [message1, setMessage1] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    // 🔌 Conectar socket al montar el provider
    if (!socket.connected) {
      console.log("🔌 Conectando socket desde SyncProvider...");
      socket.connect();
    }

    // ✅ Si se conecta, iniciar la sincronización (solo si aplica)
    const handleConnect = () => {
      console.log("✅ Socket conectado");
      // opcional: socket.emit("start_sync");
      socket.emit("join_user", {
        email: "cia@gmail.com"
      });
    };

    const handleProgress = (data) => {
      console.log("📦 sync_progress:", data);
      setProgress1(data.progress);
      setMessage1(data.message);
    };
    
    const handleDone = (data) => {
      console.log("🏁 sync_done:", data);
      setProgress1(100);
      setMessage1(data.message);
      setTimeout(() => {
        dispatch(setTradesLoadingFinished());
        dispatch(setFinishLoading());
      }, 5000);
      //dispatch(setTradesLoadingFinished());
    };

    socket.on("connect", handleConnect);
    socket.on("sync_progress", handleProgress);
    socket.on("sync_done", handleDone);

    return () => {
      console.log("🧹 Limpiando listeners de socket...");
      socket.off("connect", handleConnect);
      socket.off("sync_progress", handleProgress);
      socket.off("sync_done", handleDone);
      // no desconectamos el socket global aquí
    };
  }, []);

  // Permite usar el socket desde otros componentes
  const startSync = () => {
    if (socket.connected) {
      alert("entrando")
      socket.emit("start_sync");
      console.log("🚀 start_sync emitido");
    } else {
      console.warn("⚠️ Socket no conectado todavía");
    }
  };

  return (
    <SyncContext.Provider
      value={{
        progress1,
        setProgress1,
        message1,
        setMessage1,
        startSync, // exponemos la función para lanzar la sync
      }}
    >
      {children}
    </SyncContext.Provider>
  );
}

// Hook personalizado
export function useSync() {
  return useContext(SyncContext);
}
